module.exports = __webpack_public_path__ + "img/road-equation.9351243e.svg";